import { TextInputField, Textarea, Button, Pane, majorScale, Heading, toaster } from 'evergreen-ui';
import { ConfirmIcon, CrossIcon } from 'evergreen-ui';
import { updateCommunication} from '../services/communicationServices';
import React from 'react';
import FileUploaderMultipleUploadDemo from '../commons/FileUploaderMultipleUploadDemo';
import { DOCUMENT_MIME_TYPES_NO_WEBP } from '../constants/uploadMimeTypes';
import { useRole } from '../contexts/RoleContext';

const EditCommunicationForm = ({ editedCommunication, setEditedCommunication, handleCancelEdit, fetchCommunications, userId, setCommunications }) => {
    const { effectiveIsDirector: isDirector } = useRole();
    const [removedAttachments, setRemovedAttachments] = React.useState([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleRemoveAttachment = (attachmentName) => {
        const updatedAttachments = editedCommunication.attachments.filter(att => att.name !== attachmentName);
        setEditedCommunication({ ...editedCommunication, attachments: updatedAttachments });
        setRemovedAttachments([...removedAttachments, attachmentName]);
    };

    const handleConfirmEdit = async () => {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('title', editedCommunication.title);
            formData.append('body', editedCommunication.body);
            formData.append('communication_id', editedCommunication.id);

            const allAttachments = [
                ...(editedCommunication.attachments || []),
                ...(editedCommunication.newAttachments || []),
            ];

            allAttachments.forEach((attachment, index) => {
                if (attachment.file) {
                    formData.append(`attachments[${index}]`, attachment.file);
                }
            });

            if (removedAttachments.length > 0) {
                formData.append('remove_attachments', JSON.stringify(removedAttachments));
            }

            const resultUpdate = await updateCommunication(formData);
            if (resultUpdate.status === 'success') {
                const updatedCommunications = await fetchCommunications();
                setCommunications(updatedCommunications?.data ?? []);
                toaster.success('Comunicazione modificata con successo.');
                handleCancelEdit();
            } else {
                toaster.danger('Errore durante l\'aggiornamento della comunicazione.');
            }
        } catch (error) {
            console.error('Errore nella modifica della comunicazione:', error);
            toaster.danger('Errore nella modifica della comunicazione.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleFilesChange = (acceptedFiles) => {
        const newAttachments = acceptedFiles.map(file => ({ name: file.name, file }));
        setEditedCommunication((prev) => ({
            ...prev,
            newAttachments: [...(prev.newAttachments || []), ...newAttachments],
        }));
    };

    return (
        <Pane>
            <Heading size={600} marginBottom={16}>
                Modifica comunicazione
            </Heading>
            <TextInputField
                label="Titolo"
                value={editedCommunication.title}
                onChange={(e) => setEditedCommunication({ ...editedCommunication, title: e.target.value })}
                marginBottom={16}
            />
            <Textarea
                label="Corpo"
                value={editedCommunication.body}
                onChange={(e) => setEditedCommunication({ ...editedCommunication, body: e.target.value })}
                marginBottom={16}
                resize="none"
                height={120}
            />
            <Pane>
                <Heading size={500} marginBottom={8}>Allegati esistenti</Heading>
                {editedCommunication.attachments.map((attachment, index) => (
                    <Pane key={index} display="flex" alignItems="center" marginBottom={8}>
                        <span>{attachment.name}</span>
                        <Button intent="danger" marginLeft={8} onClick={() => handleRemoveAttachment(attachment.name)}>
                            Rimuovi
                        </Button>
                    </Pane>
                ))}
                <Heading size={500} marginBottom={8}>Nuovi allegati</Heading>
                <FileUploaderMultipleUploadDemo onFilesChange={handleFilesChange} acceptedMimeTypes={DOCUMENT_MIME_TYPES_NO_WEBP} />
            </Pane>
            <Pane display="flex" justifyContent="space-between" marginTop={majorScale(2)}>
                <Button appearance="primary" intent="success" onClick={handleConfirmEdit} isLoading={isSubmitting}>
                    Conferma modifica <ConfirmIcon marginLeft={8} />
                </Button>
                <Button intent="danger" onClick={handleCancelEdit}>
                    Annulla <CrossIcon marginLeft={8} />
                </Button>
            </Pane>
        </Pane>
    );
};

export default EditCommunicationForm;